// Legacy brands persist some brand_info sub-fields (colors, fonts, social,
// contact) as JSON-encoded strings rather than objects. Consumers iterate them
// with Object.entries / property access and assume objects, so parse any that
// arrive as JSON strings before they reach the store.
const JSON_STRING_FIELDS = ['colors', 'fonts', 'social', 'contact'];

const parseMaybeJson = value => {
  if (typeof value !== 'string') return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : value;
  } catch (error) {
    return value;
  }
};

const normalizeBrandInfoJsonFields = brandInfo => {
  if (!brandInfo) return brandInfo;
  const normalized = { ...brandInfo };
  JSON_STRING_FIELDS.forEach(field => {
    normalized[field] = parseMaybeJson(brandInfo[field]);
  });
  return normalized;
};

module.exports = normalizeBrandInfoJsonFields;
module.exports.parseMaybeJson = parseMaybeJson;
module.exports.normalizeBrandInfoJsonFields = normalizeBrandInfoJsonFields;
